var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{attrs:{"timeOut":_vm.timeOut,"verticalExpansion":_vm.verticalExpansion}},[_c('div',{class:( _obj = {}, _obj[_vm.defaultClass] = _vm.defaultClass, _obj ),staticStyle:{"cursor":"pointer"},on:{"click":function () {
      _vm.isExpanded = !_vm.isExpanded
      _vm.$emit('click')
    }}},[_vm._t("default")],2),(_vm.isExpanded)?_c('div',{class:{'fade-in': _vm.isExpanded && _vm.animation !== 0}},[_vm._t("expanded")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }